import { Audio } from "expo-av";
import { useEffect, useState } from "react";

interface Sounds {
  rotation: Audio.Sound;
}

export const useSounds = () => {
  const [sounds, setSounds] = useState<Sounds | null>(null);
  const [isReady, setIsReady] = useState(false);

  const _init = async () => {
    const rotation = new Audio.Sound();
    try {
      await rotation.loadAsync(require("../assets/sounds/rotation.mp3"));
      setSounds({
        rotation,
      });
      console.log("Sounds init done.");
    } catch (error) {
      console.error(error);
    }
  };

  const _destroy = async () => {
    try {
      if (sounds) {
        (Object.keys(sounds) as (keyof Sounds)[]).map(async (key) => {
          await sounds[key].stopAsync();
          await sounds[key].unloadAsync();
        });
        setSounds(null);
        console.log("Sounds destroy done.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const play = async (soundType: keyof Sounds, isLooping = false) => {
    if (sounds === null) return;
    const _sound = sounds[soundType];
    try {
      await _sound.setPositionAsync(0);
      await _sound.setIsLoopingAsync(isLooping);
      await _sound.playAsync();
    } catch (error) {
      console.error(error);
    }
  };

  const playRandom = async (soundType: keyof Sounds, perCount: number) => {
    if (sounds === null) return;
    if (Math.floor(Math.random() * perCount) === 0) {
      await play(soundType);
    }
  };

  const stop = async (soundType: keyof Sounds) => {
    if (sounds === null) return;
    const _sound = sounds[soundType];
    try {
      await _sound.stopAsync();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    (async () => {
      await _init();
      setIsReady(true);
    })();
    return () => {
      (async () => {
        await _destroy();
      })();
    };
  }, []);

  return {
    play,
    playRandom,
    stop,
    isReady,
  };
};
